module.exports = __webpack_public_path__ + "img/nol-bottom.15cb046f.png";